import React, { useCallback, useEffect, useRef, useState } from 'react';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import EventAdminPanel from './EventAdminPanel';
import MemberAdminPanel from './MemberAdminPanel';
import './aiProfile.css';

export default function AIProfilePage() {
    const [authorized, setAuthorized] = useState(false);
    const [tab, setTab] = useState('event');
    const [notice, setNotice] = useState('관리자 정보를 확인하고 있어요.');
    const pending = useRef(new AbortController());
    useEffect(() => {
        const controller = pending.current;
        RefreshCheckApi.get('/admin/check', { signal: controller.signal })
            .then((response) => {
                if (controller.signal.aborted) return;
                const allowed = Number(response.data.info?.role) === 1;
                setAuthorized(allowed);
                setNotice(allowed ? '' : '관리자만 접근할 수 있어요.');
            })
            .catch(() => {
                if (!controller.signal.aborted) setNotice('관리자 정보를 확인하지 못했어요.');
            });
        const logout = (event) => {
            if (['access_token', 'user_id'].includes(event.key) && event.newValue === null) {
                pending.current.abort();
                setAuthorized(false);
                setNotice('다시 로그인해 주세요.');
            }
        };
        window.addEventListener('storage', logout);
        return () => {
            pending.current.abort();
            window.removeEventListener('storage', logout);
        };
    }, []);
    const api = useCallback(async (path, payload, method = payload === undefined ? 'GET' : 'POST', config = {}) => {
        const response = await RefreshCheckApi.request({ url: '/adminUser/aiProfile/event/' + path, method, data: payload, signal: pending.current.signal, ...config });
        return response.data.data;
    }, []);
    const changeTab = (next) => {
        if (next === tab) return;
        pending.current.abort();
        pending.current = new AbortController();
        setTab(next);
    };
    return (
        <section className="ai-profile-page">
            <h1>AI 프로필</h1>
            <p role="status">{notice}</p>
            {authorized && (
                <>
                    <nav aria-label="AI 프로필 구분">
                        <button type="button" aria-pressed={tab === 'event'} onClick={() => changeTab('event')}>
                            행사용
                        </button>
                        <button type="button" aria-pressed={tab === 'member'} onClick={() => changeTab('member')}>
                            회원용
                        </button>
                    </nav>
                    {tab === 'event' ? <EventAdminPanel api={api} /> : <MemberAdminPanel />}
                </>
            )}
        </section>
    );
}
